export enum ModalConstants {
  TRAVEL_VOUCHER_NOT_AVAILABLE = 'transportVoucherNotAvailable',
  INVALID_DAMAGED_GOOD = 'invalidDamagedGood',
  DECLARATION_CANNOT_BE_REGISTERED = 'declarationCannotBeRegistered',
  VOUCHER_GENERATION_CONFIRMATION = 'voucherGenerationConfirmation',
  RECLAMATION_TO_MERCHANT = 'reclamationToMerchnat',
  OVERTAKING_DATE = 'overTakingDate',
  HAVE_IN_PROGRESS_CLAIM = 'haveInProgressClaim',
  OUT_OF_WARRANTY = 'outOfWarranty',
  IF_DID_THE_SELLING_DECLARANT_CREATE_THE_SUBSCRIPTION = 'ifDidTheSellingDeclarantCreateTheSubscription'
}

export enum PagePart {
  APP_GLOBAL_TYPE = 'appGlobalType',
  GENERIC_SIDE_NAV_PDV = 'genericSideNavPdv',
  POP_IN = 'popIn',
  SIDE_BAR_MOBILE = 'sideBarMobile',
  CONTRACT_DOCUMENTS = 'contractDocuments',
}

export enum ContentType {
  LEGAL_NOTICE = 'LEGAL_NOTICE',
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
}


export enum Step {
  GET_FIRST_STEP = 'getFirstStep',
  JOURNEY_HOME_PAGE = 'journeyHomePage',
  COVER_SELECTION = 'coverSelection',
  CONTACT_MODE = 'contactMode',
  CONTACT_FORM = 'contactForm',
  CLAIM_DECLARE_CONTACT_FORM = 'claimDeclareContactForm',
  CONFIRM_EMAIL = 'confirmEmail',
  NEED_HELP = 'needHelp',
  DAMAGED_GOOD_FAMILY = 'damagedGoodFamily',
  DAMAGED_GOOD_SELECTION = 'damagedGoodSelection',
  CUSTOMER_INFORMATION = 'customerInformation',
  DAMAGED_GOOD_IMEI_VALIDATION = 'damagedGoodImeiValidation',
  DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION = 'damagedGoodSerialNumberValidation',
  DAMAGED_GOOD_CREATION = 'damagedGoodCreation',
  DAMAGED_GOOD_USER_CONFIRMATION = 'damagedGoodUserConfirmation',
  DAMAGED_GOOD_USER_CREATION = 'damagedGoodUserCreation',
  DAMAGED_GOOD_DATE = 'damagedGoodDate',
  CLAIM_TRIGGER_NATURE = 'claimTriggerNature',
  DAMAGED_GOOD_CIRCONSTANCES = 'damagedGoodCirconstances',
  EXTERNAL_DAMAGE_CONFIRMATION = 'externalDamageConfirmation',
  CLAIM_RESULT_FREE_ENTRY = 'claimResultFreeEntry',
  CLAIM_RESULT_SELECTION = 'claimResultSelection',
  CHOOSE_DAMAGED_GOODS = 'chooseDamagedGoods',
  DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY = 'damagedGoodDysfunctionFreeEntry',
  DAMAGED_GOOD_DYSFUNCTION_SELECTION = 'damagedGoodDysfunctionSelection',
  DAMAGED_GOOD_ACCESSORIES_VALIDATION = 'damagedGoodAccessoriesValidation',
  CLIENT_DETAILS_CONFIRMATION = 'clientDetailsConfirmation',
  UPDATE_CLIENT_DETAILS = 'updateClientDetails',
  DECLARATION_SUMMARY = 'declarationSummary',
  IMPROVEMENT_QUALITY = 'improvementQuality',
  DECLARATION_CONFIRMATION = 'declarationConfirmation',
  TRAVEL_ASSISTANCE = 'travelAssistance',
  DAMAGED_GOOD_PROPER_USE_CONFIRMATION = 'damagedGoodProperUseConfirmation',
  OTHER_CLAIM_TRIGGER_NATURE = 'otherClaimTriggerNature',
  DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION = 'damagedGoodProperFunctioningConfirmation',
  DEVICE_DOES_NOT_TURN_ON_CONFIRMATION = 'deviceDoesNotTurnOnConfirmation',
  DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION = 'damagedGoodReparationPeriodConfirmation',
  DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE = 'damagedGoodReparationPeriodConfirmationApple',
  DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION = 'damagedGoodReplacedPeriodConfirmation',
  DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION_APPLE = 'damagedGoodReplacedPeriodConfirmationApple',
  DAMAGE_OBSERVED_FREE_ENTRY = 'damageObservedFreeEntry',
  STOLEN_TYPE_SELECTION = 'stolenTypeSelection',
  PHYSICAL_VIOLENCE_CONFORMATION = 'physicalViolenceConfirmation',
  THEFT_INSURED_PERSON_ELIGIBILITY = 'theftInsuredPersonEligibility',
  THEFT_PLACE_SELECTION = 'theftPlaceSelection',
  THEFT_ADDRESS_VALIDATION = 'theftAddressValidation',
  THEFT_ACCESSORIES_VALIDATION = 'theftAccessoriesValidation',
  THEFT_POLICE_REPORT_CONFIRMATION = 'theftPoliceReportConfirmation',
  DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION = 'deviceSimCardInOppositionConfirmation',
  REMPLACEMENT_DEVICE_NEW_SIM_REQUEST = 'remplacementDeviceNewSimRequest',
  BURGLARY_DEVICE_SELECTION = 'burglaryDeviceSelection',
  BURGLARY_LOCATION_ACTIVE_CONFIRMATION = 'burglaryLocationActiveConfirmation',
  EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION = 'externalProductVisibleConfirmation',
  CLANDESTINE_INTRODUCTION_PLACE_SELECTION = 'clandestineIntroductionPlaceSelection',
  INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION = 'introductionClandestinePlaceOccupiedConfirmation',
  PRODUCT_IN_HAND_CONFIRMATION = 'productInHandConfirmation',
  PRODUCT_IN_POCKET_CONFIRMATION = 'productInPocketConfirmation',
  PRODUCT_IN_BAG_CONFIRMATION = 'productInBagConfirmation',
  CLAIM_DECLARE_EVENT_DATE = 'ClaimDeclareEventdate',
  LOADING_LAYOUT_CONTENT = 'LoadingLayoutContent',
  PARKOUR_CLIENT_DETAILS_CONFIRMATION = 'ParkourClientDetailsConfirmation',
  BENEFIT_TYPE_SELECTION = 'benefitTypeSelection',
  BENEFIT_TYPE_SELECTION_APPLE = 'benefitTypeSelectionApple',
  BENEFIT_DEPOSIT_METHOD = 'benefitDepositMethod',
  DEVICE_PATTERN_LOCK = 'devicePatternLock',
  REGISTERED_STATEMENT = 'registeredStatement',
  TRANSPORT_VOUCHER_GENERATION_VALIDATION = 'transportVoucherGenerationValidation',
  TRANSPORT_VOUCHER_GENERATION_INFORMATION = 'transportVoucherGenerationInformation',
  UPDATE_BENEFIT_ADDRESS_DETAILS = 'updateBenefitAddressDetails',
  INSTRUCTIONS_FOR_PACKING = 'instructionsForPacking',
  TRANSPORT_VOUCHER_GENERATION = 'transportVoucherGeneration',
  BENEFIT_INFORMATIVE_MESSAGE_DATA_SECURITY = 'benefitInformativeMessageDataSecurity',
  REGISTERED_STATEMENT_WITH_ANNOUNCEMENT = 'registeredStatementWithAnnouncement',
  BENEFIT_POINT_SELECTION = 'benefitPointSelection',
  BENEFIT_CHOSEN_RELAY_POINT_VALIDATION = 'benefitChosenRelayPointValidation',
  BENEFIT_CHOSEN_PROXIMITY_POINT_VALIDATION = 'benefitChosenProximityPointValidation',
  INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE = 'instructionsForDeactivatingFindMyIphone',
  DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION = 'deactivateDeviceGeolocationConfirmation',
  REFERENTIAL_ITEMS = 'referentialItems',
  SUPPORTING_DOCUMENTS = 'supportingDocuments',
  CLAIM_LOCATION = 'claimLocation',
  UPLOAD_DECLARATION = 'uploadDeclaration',
  CONTACT_MANAGEMENT_SERVICE = 'contactManagementService',
  DEADLINE_REMINDER_CONFIRMATION = 'deadlineReminderConfirmation',
  COMPLAINED_TO_MERCHANT_CONFIRMATION = 'complainedToMerchantConfirmation',
  CAPITAL_SHIPPING_ADDRESS_CONFIRMATION = 'capitalShippingAddressConfirmation',
  CLAIM_DECLARATION_DATE = 'claimDeclarationDate',
  CONCERNED_ELEMENT_SELECTION = 'concernedElementSelection',
  COMPLAINED_TO_POLICE_REMINDER = 'complainedToPoliceReminder',
  EXTERNAL_REFERENCE = 'externalReference',
  RELATIONSHIP_TO_THE_VICTIM = 'relationshipToTheVictim',
  DAMAGED_GOOD_ACCESSORIES_SELECTION = 'damagedGoodAccessoriesSelection',
  RECOVERY_METHOD = 'recoveryMethod',
  UPDATE_RECOVERY_ADDRESS = 'updateRecoveryAddress',
  COMPLAINED_TO_POLICE_CONFIRMATION = 'complainedToPoliceConfirmation',
  OVERSEAS_DEPARTMENTS_AND_TERRITORIES_REMINDER = 'overseasDepartmentsAndTerritoriesReminder',
}

export const SummarySteps = [
  Step.EXTERNAL_REFERENCE,
  Step.COVER_SELECTION,
  Step.DAMAGED_GOOD_DATE,
  Step.CLAIM_LOCATION,
  Step.UPLOAD_DECLARATION,
  Step.CLAIM_TRIGGER_NATURE,
  Step.EXTERNAL_DAMAGE_CONFIRMATION,
  Step.CLAIM_RESULT_SELECTION,
  Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION,
  Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION,
  Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION,
  Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION,
  Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION,
  Step.CHOOSE_DAMAGED_GOODS,
  Step.OTHER_CLAIM_TRIGGER_NATURE,
  Step.DAMAGED_GOOD_CIRCONSTANCES,
  Step.CLAIM_RESULT_FREE_ENTRY,
  Step.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY,
  Step.DAMAGE_OBSERVED_FREE_ENTRY,
  Step.THEFT_INSURED_PERSON_ELIGIBILITY,
  Step.CLANDESTINE_INTRODUCTION_PLACE_SELECTION,
  Step.BURGLARY_DEVICE_SELECTION,
  Step.THEFT_PLACE_SELECTION,
  Step.THEFT_ADDRESS_VALIDATION,
  Step.THEFT_ACCESSORIES_VALIDATION,
  Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION,
  Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE,
  Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION,
  Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION_APPLE,
  Step.PHYSICAL_VIOLENCE_CONFORMATION,
  Step.BURGLARY_LOCATION_ACTIVE_CONFIRMATION,
  Step.EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION,
  Step.INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION,
  Step.PRODUCT_IN_POCKET_CONFIRMATION,
  Step.PRODUCT_IN_HAND_CONFIRMATION,
  Step.PRODUCT_IN_BAG_CONFIRMATION,
  Step.THEFT_POLICE_REPORT_CONFIRMATION,
  Step.DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION,
  Step.REMPLACEMENT_DEVICE_NEW_SIM_REQUEST,
  Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION,
  Step.DEADLINE_REMINDER_CONFIRMATION,
  Step.CONCERNED_ELEMENT_SELECTION,
  Step.COMPLAINED_TO_POLICE_REMINDER,
  Step.CLAIM_DECLARATION_DATE,
  Step.COMPLAINED_TO_POLICE_CONFIRMATION,
  Step.UPDATE_RECOVERY_ADDRESS,
];

export enum CustomerEntryName {
  JOURNEY_ROUTE_SELECTED = 'JOURNEY_ROUTE_SELECTED',
  COVER_CHOICE = 'COVER_CHOICE',
  IMEI_CONFIRMATION = 'IMEI_CONFIRMATION',
  USER_CONFIRMATION = 'USER_CONFIRMATION',
  EXTERNAL_DAMAGE_CONFIRMATION = 'EXTERNAL_DAMAGE_CONFIRMATION',
  DAMAGED_GOOD_TYPE = 'DAMAGED_GOOD_TYPE',
  CORDINATES_UPDATE = 'CORDINATES_UPDATE',
  OTHER_DAMAGED_GOOD_SELECTION = 'OTHER_DAMAGED_GOOD_SELECTION',
  SELECTED_INSURED_GOOD = 'SELECTED_INSURED_GOOD',
  BRAND_SELECTED_INSURED_GOOD = 'BRAND_SELECTED_INSURED_GOOD',
  MODEL_SELECTED_INSURED_GOOD = 'MODEL_SELECTED_INSURED_GOOD',
  PURCHASE_DATE_SELECTED_INSURED_GOOD = 'PURCHASE_DATE_SELECTED_INSURED_GOOD',
  CLAIM_TRIGGER_NATURE = 'CLAIM_TRIGGER_NATURE',
  CLAIM_RESULT_SELECTION = 'CLAIM_RESULT_SELECTION',
  PROPER_USE_CONFIRMATION = 'PROPER_USE_CONFIRMATION',
  PROPER_FUNCTIONING_CONFIRMATION = 'PROPER_FUNCTIONING_CONFIRMATION',
  DEVICE_DOES_NOT_TURN_ON_CONFIRMATION = 'DEVICE_DOES_NOT_TURN_ON_CONFIRMATION',
  REPARATION_PERIOD_CONFIRMATION = 'REPARATION_PERIOD_CONFIRMATION',
  REPLACED_PERIOD_CONFIRMATION = 'REPLACED_PERIOD_CONFIRMATION',
  STOLEN_TYPE_CHOICE = 'STOLEN_TYPE_CHOICE',
  LOCATION_TYPE_CHOICE = 'LOCATION_TYPE_CHOICE',
  POCKET_CONFIRMATION = 'POCKET_CONFIRMATION',
  DEPOSIT_METHOD = 'DEPOSIT_METHOD',
  BENEFIT_TYPE_SELECTION = 'BENEFIT_TYPE_SELECTION',
  BENEFIT_POINT_SELECTION = 'BENEFIT_POINT_SELECTION',
  TRANSPORT_VOUCHER_GENERATION_ACTION = 'TRANSPORT_VOUCHER_GENERATION_ACTION',
  REGISTERED_STATEMENT_WITH_ANNOUNCEMENT = 'REGISTERED_STATEMENT_WITH_ANNOUNCEMENT_ACTION',
  REGISTERED_STATEMENT = 'REGISTERED_STATEMENT',
  REFUSAL_DETECTED = 'REFUSAL_DETECTED',
  DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION_ACTION = 'DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION_ACTION',
  IS_RIGHT_GOOD = 'IS_RIGHT_GOOD',
  FROM_SPECIFIC_STEP = 'FROM_SPECIFIC_STEP',
  PROVIDER = 'PROVIDER',
  CLAIM_NUMBER = 'CLAIM_NUMBER',
  COMPLAINED_TO_MERCHANT_CONFIRMATION = 'COMPLAINED_TO_MERCHANT_CONFIRMATION',
  INCIDENT_DATE = 'INCIDENT_DATE',
  THEFT_INSURED_PERSON_ELIGIBILITY = 'THEFT_INSURED_PERSON_ELIGIBILITY',
  CAPITAL_ADDRESS = 'CAPITAL_ADDRESS',
  DAMAGED_GOOD_CIRCONSTANCES = 'DAMAGED_GOOD_CIRCONSTANCES',
  DAMAGE_OBSERVED_FREE_ENTRY = 'DAMAGE_OBSERVED_FREE_ENTRY',
  DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY = 'DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY',
  CLAIM_RESULT_FREE_ENTRY = 'CLAIM_RESULT_FREE_ENTRY',
  IS_MATCHED_IFR = 'IS_MATCHED_IFR',
  ACCESSORIES_VALIDATION = 'ACCESSORIES_VALIDATION',
  ACCESSORIES_PURCHASE_PRICE = 'ACCESSORIES_PURCHASE_PRICE',
  ACCESSORIES_SELECTION = 'ACCESSORIES_SELECTION',
  RECOVERY_METHOD = 'RECOVERY_METHOD',
  COMPLAINED_TO_POLICE_CONFIRMATION = 'COMPLAINED_TO_POLICE_CONFIRMATION',
  DEVICE_PATTERN_LOCK = 'DEVICE_PATTERN_LOCK',
  CUSTOMER_FIRST_NAME = 'CUSTOMER_FIRST_NAME',
  CUSTOMER_LAST_NAME = 'CUSTOMER_LAST_NAME',
  CUSTOMER_EMAIL = 'CUSTOMER_EMAIL',
  CUSTOMER_PHONE = 'CUSTOMER_PHONE',
  CUSTOMER_BIRTH_DATE = 'CUSTOMER_BIRTH_DATE',
  CUSTOMER_NATIVE_COUNTRY = 'CUSTOMER_NATIVE_COUNTRY',
  CUSTOMER_BIRTH_CITY = 'CUSTOMER_BIRTH_CITY',
  CUSTOMER_CIVILITY = 'CUSTOMER_CIVILITY',
  CUSTOMER_COUNTRY = 'CUSTOMER_COUNTRY',
  CUSTOMER_CITY = 'CUSTOMER_CITY',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',
  CUSTOMER_POSTAL_CODE = 'CUSTOMER_POSTAL_CODE',
  CUSTOMER_STREET_NUMBER = 'CUSTOMER_STREET_NUMBER',

}

export enum DepositMethodeCode {
  BP = 'BP',
  PR = 'PR',
  PP = 'PP',
}

export enum StepAction {
  INSTRUCTIONS = 'INSTRUCTIONS',
  NEXT_STEP = 'NEXT_STEP',
  CHOOSE_PROXIMITY_POINT = 'CHOOSE_PROXIMITY_POINT',
  UPDATE_BENEFIT_POINT_SELECTION = 'UPDATE_BENEFIT_POINT_SELECTION',
  UPDATE_ADDRESS = 'UPDATE_ADDRESS',
  VOUCHER_GENERATION_CONFIRMATION = 'VOUCHER_GENERATION_CONFIRMATION',
}

export enum StepEngineBehaviorsConstants {
  RESET_STEP_ENGINE = 'resetStepEngine',
  COVER = 'cover',
  PREVIOUS_COVER = 'previousCover',
  ITEMS = 'items',
  SAVE_DECLARATION = 'saveDeclaration',
  ENABLE_NEXT_BUTTON = 'enableNextButton',
  HIDE_FROM_RECAP = 'hideFromRecap',
  HIDE_PREVIOUS_BUTTON = 'hidePreviousButton',
  HIDE_NEXT_BUTTON = 'hideNextButton',
  ADD_PREVIOUS_STEP = 'addPreviousStep',
  IGNORE_COMMENT = 'ignoreComment',
  SHOW_STEP_ACTION = 'showStepAction',
  STEP_GROUP = 'stepGroup',
  DONT_SHOW_POPUP_REDIRECT_URL = 'dontShowPopupRedirectUrl',
  PROGRESS_BAR = 'progressBar',
  IS_NOT_REDIRECT = 'isNotRedirect',
  UPLOAD_REF_DOCUMENT = 'uploadRefDocument',
  SIDE_BAR_CONTENT = 'sideBarContent',
  FOOTER_CONTENT = 'footerContent',
  CREATE_CONTACT = 'createContact',
  CREATE_FIRST_CONTACT = 'createFirstContact',
  SHOW_MODAL = 'showModal',
  HANDLE_PREVIOUS_STEP_ON_MODAL_CLOSE = 'handlePreviousStepOnModalClose',
  HANDLE_BACK_TO_HOME_ON_MODAL_CLOSE = 'handleBackToHomeOnModalClose',
  HANDLE_CONTACT_US_LOUNGE = 'handleContactUsLounge',
  ENABLE_VALIDATION = 'enableValidation',
  UNIQUE_IDENTIFIER = 'uniqueIdentifier',
  IS_VALID = 'isValid',
  DETECT_REFUSAL = 'detectRefusal',
  GEO_LOCATION_POST_ACTION = 'geoLocationPostAction',
  BACK_TO_HOME = 'backToHome',
  CHOOSE_PROXIMITY_POINT = 'chooseProximityPoint',
  GO_TO_PREVIOUS_STEP = 'goToPreviousStep',
  GO_TO_NEXT_STEP = 'goToNextStep',
  DEPOSIT_METHOD = 'depositMethod',
  PROVOKE_BACKWARD = 'provokeBackward',
  DAMAGED_GOOD_DETAILS = 'damagedGoodDetails',
  JOURNEY_DATA = 'journeyData',
  CONTACT_REASON = 'contactReason',
  REDIRECT_TO_LOUNGE = 'redirectToLounge',
  INIT_DAMAGED_GOODS = 'initDamagedGoods',
  HANDLE_NEXT_ACTION = 'handleNextAction',
  RENDER_SPECIFIC_STATEMENT= 'renderSpecificStatement',
  ONLY_ACTIVE_INSURED_GOOD = 'onlyActiveInsuredGood',
  MODAL_HANDLE_BACK_TO_HOME = 'modalHandleBackToHome',
  HANDLE_NEXT_STEP = 'handleNextStep',
  SHOW_RATING_MODAL = 'showRatingModal',
  BENEFIT_TYPE_SELECTION = 'benefitTypeSelection',
  GTM_TAG_STEPS = 'gtmTagSteps',
  IS_UNIQUE = 'isUnique',
  SET_SUBSCRIPTION_ELIGIBILITY = 'subscriptionEligibility',
  SHOW_CUSTOMER_AREA_BUTTON = 'showCustomerAreaButton',
  MIN_LENGTH_SERIAL_NUMBER = 'minLengthSerialNumber',
  MAX_LENGTH_SERIAL_NUMBER = 'maxLengthSerialNumber',
  HIDE_STICKY_RECAP = 'hideStickyRecap',
  FORCE_NEXT_STEP_ON_SELECTION = 'forceNextStepOnSelection',
  RESET_COVER = 'resetCover',
  SHOW_IMEI = 'showIMEI',
  MIN_DATE = 'minDate',
  HIDE_FIELDS = 'hideFields',
  DONT_RELOAD_DATA = 'dontReloadData',
  CHECK_EXISTING_BENEFIT = 'checkExistingBenefit',
  CREATE_ORDER = 'createOrder',
  CREATE_BENEFIT = 'createBenefit',
  UPDATE_BENEFIT = 'updateBenefit',
  VALIDATE_BENEFIT = 'validateBenefit',
  UPDATE_CLIENT_ADDRESS = 'updateClientAddress',
  UPDATE_CLIENT_SHIPPING_ADDRESS = 'updateClientShippingAddress',
  OVERWRITE_CLIENT_SHIPPING_ADDRESS = 'overwriteClientShippingAddress',
  TERMINATE_CLAIM = 'terminateClaim',
  SEARCH_USE_CASES = 'searchUseCases',
  CREATE_BENEFIT_ADDRESS = 'createBenefitAddress',
  MODAL_REDIRECT_TO_LOUNGE = 'modalRedirectToLounge',
  MULTIPLE_CUSTOMER_ENTRIES = 'multipleCustomerEntries'
}

export enum StepEngineStepGroup {
  COVERAGE = 'COVERAGE',
  SINGLE = 'SINGLE',
}
